// logo
import logoBlue from './logo-blue.png'
import logoBlack from './logo-black.png'
import logoWhite from './logo-white.png'
//input checkbox
import serviceInput from './input-service.png'
import defaultInput from './input-default.png'
import checkedInput from './input-checked.png'
//logo service
import logoBaemin from './logo-baemin.png'
import logoYogiyo from './logo-yogiyo.png'
import logoCoupang from './logo-coupangeats.png'
//etc
import caution from './caution.png'
import tooltip from './tooltip.png'
import success from './subscription.png'
import call from './call.png'

// logo
import logo_spge from './logo/logo_spge.png'
import logo_spgeR_scroll from './logo/logo_spgeR_scroll.png'
import logo_spgeR from './logo/logo_spgeR.png'

import icon_calendar from './icon/icon_calendar.png'
import refresh from './icon/refresh.png'

// section
import review_img01 from './section1/01_review_img01.png'
import review_img02 from './section1/01_review_img02.png'
import review_img03 from './section1/01_review_img03.png'
import review_img04 from './section1/01_review_img04.png'
import review_srats from './section1/01_review_srats.png'
import img_intro1_1 from './intro1/intro1-1.png'
import img_intro1_2 from './intro1/intro1-2.png'
import img_intro1_3 from './intro1/intro1-3.png'
import img_intro1_4 from './intro1/intro1-4.png'
import chat_img01 from './section2/02_chat_img01_v2.png'
import chat_img02 from './section2/02_chat_img02_v2.png'
import chat_img03 from './section2/02_chat_img03_v2.png'
// import chat_img04 from './section2/02_chat_img04.png'
import phone_img from './section2/02_phone_img.png'
import mask from './section2/mask.png'

import card_img_03_01 from './section3/03_card_img01.png'
import card_img_03_02 from './section3/03_card_img02.png'

import img_plus from './section4/04_img_plus.png'
import img01 from './section4/04_img01.png'
import img02 from './section4/04_img02.png'
import img03 from './section4/04_img03.png'

import card_img01 from './section5/05_card_img01.png'
import card_img02 from './section5/05_card_img02.png'
import card_img03 from './section5/05_card_img03.png'

import timeline from './section6/timeline.png'

import img_07_01 from './section7/07_img01.png'

//review
import interest_img1 from './review/Image1.png'
import interest_img2 from './review/Image2.png'
import btn_change from './review/btn_change.svg'
import btn_close from './review/btn_close.svg'
import review_guide_icon from './review/review_guide_icon.png'
import review_guide_img01 from './review/btn_guide_img01.png'
import review_guide_img02 from './review/btn_guide_img02.png'
import upload from './upload.svg'
import apple from './apple.svg'
import google_play from './google-play.svg'
import arrow_right from './arrow-right.svg'
import arrow_right_large from './arrow_right_large.svg'
import phone_confeti from './phone-confeti.png'
import logo_square_svg from './logo-square.svg'
import dot_normal from './dot-normal.svg'
import dot_failure from './dot-failure.svg'
import dot_unlinked from './dot-unlinked.svg'
import chat_icon from './icon/chat.png'
import comment_icon from './icon/comment.png'
import like_icon from './icon/like.png'

import promotion_title from './promotion_title.png'
import promotion_sub from './promotion_sub.png'
import promotion_content from './promotion_content.png'

const images = {
  logo_spge,
  logo_spgeR_scroll,
  logo_spgeR,
  review_img01,
  review_img02,
  review_img03,
  review_img04,
  review_srats,
  chat_img01,
  chat_img02,
  chat_img03,
  // chat_img04,
  phone_img,
  mask,
  card_img_03_01,
  card_img_03_02,
  img_plus,
  img01,
  img02,
  img03,
  card_img01,
  card_img02,
  card_img03,
  timeline,
  img_07_01,
  logoBlue,
  logoBlack,
  logoWhite,
  logoBaemin,
  logoYogiyo,
  logoCoupang,
  serviceInput,
  defaultInput,
  checkedInput,
  caution,
  tooltip,
  success,
  call,
  icon_calendar,
  refresh,
  interest_img1,
  interest_img2,
  btn_change,
  btn_close,
  review_guide_icon,
  review_guide_img01,
  review_guide_img02,
  upload,
  img_intro1_1,
  img_intro1_2,
  img_intro1_3,
  img_intro1_4,
  apple,
  google_play,
  arrow_right,
  arrow_right_large,
  phone_confeti,
  logo_square_svg,
  dot_normal,
  dot_failure,
  dot_unlinked,
  chat_icon,
  comment_icon,
  like_icon,
  promotion_title,
  promotion_sub,
  promotion_content
}
export { images }
